import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'config/config';
import { suppressResizeObserverError } from './utils/suppressResizeObserverError';
import { Spin } from 'antd';
import { handleUpdateFound } from './pwaUpdate';
import { showUpdatePrompt } from './pwaUpdatePrompt';
import { LoadingOutlined } from '@ant-design/icons';

suppressResizeObserverError();

// Indicator teal, gọn gàng cho MỌI <Spin> trong app (đồng bộ, chuyên nghiệp)
Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 26, color: 'var(--primary-color, #004c4c)' }} spin />);
import { Provider } from 'react-redux';
// import { store } from '@app/store/store';
import reducers from './store/reducers';
import middleware from './store/middlewares';

import { createRoot } from 'react-dom/client';
import React from 'react';
import { createStore } from '@reduxjs/toolkit';

const store = createStore(reducers, middleware);
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// Có bản mới: app đang ẩn thì cập nhật luôn; đang dùng thì hỏi bằng hộp thoại xác nhận chung
// (tự cập nhật khi app bị ẩn lần tới nếu chọn "Để sau").
serviceWorkerRegistration.register({
  onUpdate: (registration) => handleUpdateFound(registration, { prompt: showUpdatePrompt }),
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
